import { FlagIcon } from "@heroicons/react/20/solid";
import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
};
export const PriorityIcon = ({ className }: Props) => (
  <FlagIcon className={twMerge("h-5 w-5 text-rose-400", className)} />
);
